import React from 'react';
import { connect } from 'react-redux';
import { Field, change, reduxForm } from 'redux-form';
import { PropTypes } from 'prop-types';
import { Button, FormGroup, Form } from 'reactstrap';

import FormItem from '../../../common/forms/FormItem';
import FormFooter from '../../../common/forms/FormFooter';
import CompanyResourceSelect from '../../../common/forms/select/CompanyResourceSelect';
import CompanyResourceGroupSelect from '../../../common/forms/select/CompanyResourceGroupSelect';

const validateCompanyResourceOrGroup = (value, allValues) => {
  const { companyResourceId, companyResourceGroupId } = allValues;

  const isNotEmpty = (val) => {
    if (val === null || val === undefined) {
      return false;
    }

    if (Array.isArray(val)) {
      return val.length > 0;
    }

    if (typeof val === 'object') {
      return Object.keys(val).length > 0;
    }

    return val !== '';
  };

  const validFields = [companyResourceId, companyResourceGroupId].filter(
    isNotEmpty,
  );

  if (validFields.length === 0) {
    return 'Debe seleccionar Recursos de Compañía o Grupo de Recursos de Compañía.';
  }

  if (validFields.length > 1) {
    return 'Solo debe seleccionar Recursos de Compañía o Grupo de Recursos de Compañía.';
  }

  return undefined;
};

const AddResourcePreventiveTaskForm = ({
  handleSubmit,
  handleProcess,
  onCancel,
}) => (
  <Form onSubmit={handleSubmit(handleProcess)}>
    <p>Seleccione los recursos que desea agregar</p>
    <hr />

    <FormGroup row className="mt-4">
      <FormItem label="Recursos de Compañía">
        <Field
          name="companyResourceId"
          component={CompanyResourceSelect}
          isClearable
          isMulti
          validate={[validateCompanyResourceOrGroup]}
        />
      </FormItem>
    </FormGroup>

    <FormGroup row className="mt-4">
      <FormItem label="Grupo de Recursos de Compañía">
        <Field
          name="companyResourceGroupId"
          component={CompanyResourceGroupSelect}
          isClearable
          isMulti
          validate={[validateCompanyResourceOrGroup]}
        />
      </FormItem>
    </FormGroup>

    <FormFooter
      saveButtonColor="info"
      saveButtonIcon="fa fa-plus-circle"
      saveButtonText="Agregar"
    >
      <Button color="primary" onClick={onCancel}>
        Cancelar
      </Button>
    </FormFooter>
  </Form>
);

AddResourcePreventiveTaskForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleProcess: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchChange: change,
};

const formComponent = reduxForm({
  form: 'AddResourcePreventiveTaskForm',
})(AddResourcePreventiveTaskForm);

export default connect(null, mapDispatchToProps)(formComponent);
